"use strict";
export const VDLockMock = (mock) => {
  mock.onPost(/\/v1\/virtual-desktops\/(\d+)\/lock/).reply((cofig) => {
    let _response = {};
    return [200, _response];
  });
  mock.onDelete(/\/v1\/virtual-desktops\/(\d+)\/lock/).reply((config) => {
    let _response = {};
    return [200, _response];
  });
};
